export const colors = {
    darkGrey: '#333333',
};